import React  from 'react';
import GuestNavBar from "../pages/GuestPage/GuestNavbar/GuestNavbar";
import { Container, Card, Row, Col} from "reactstrap";
import Title from "views/Hoc/Dialog/Title";
import image1 from "assets/img/icons/404img.jpg";
import image2 from "assets/img/common/eventnotfoundbanner.png";
import { history } from '_helpers';
const NotFound = () => {
    return (
        <div className='main-content'>
            <GuestNavBar />
           <div>
        <Container fluid>
        <Card className="pg-card">
               <Row>
            <Col xs="12">       
        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-6 pg-content1">
            <figure className="pgimg">
                <img src={image1} alt="" title="404 page no found" />
            </figure>
        </div>
        <div className="col-lg-7 col-md-7 col-sm-7 col-xs-6 pg-content" style={{ backgroundImage: `url(${image2})` , backgroundRepeat : 'no-repeat', backgroundSize:'600px', height: '75%', }}>
        
        {/* <h1>Whoops,nothing to see here.</h1> */}
        <div style={{marginTop:'75px' ,width:'80%', alignContent:'center'}}>
        <p style={{fontSize:'18px', }}>The event is now closed, please visit our home page to  find out our next events details.</p>
        <div style={{width:'50%'}}>
        <a onClick={e => window.open("https://www.channel-summit.com",'_blank')} className="pg-a" style={{ float:'right'}} >Go to home page</a>
        </div>
        </div>
        </div>
        </Col>  
        </Row>
        </Card>
        </Container>
    </div>

       

        </div>
    )
}
export default NotFound;